import { UPDATE_AID_YEAR, RESET_GLOBAL, FETCH_INTERVIEW_TYPES_ALL, SET_DEFAULT_AID_YEAR } from "../actions/types";

//Set initial state to the most recent aid year
const INITIAL_STATE = {
  aidYear: 2021,
  aidYearStart: 2020,
  aidYearString: "2020-2021",
  taxYear: 2018,
  interviewTypesAll: null
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  var prevYear = parseInt(action.payload) - 1;
  var taxYear = parseInt(action.payload) - 3;
  switch (action.type) {
    case SET_DEFAULT_AID_YEAR:
      const aidYear = action.payload;
      if (aidYear) {
        const defaultAidYearStart = aidYear-1
        const defaultTaxYear = defaultAidYearStart - 2;
        return {
          ...state,
          aidYear: aidYear,
          aidYearString: `${defaultAidYearStart}-${aidYear}`,
          aidYearStart: defaultAidYearStart,
          taxYear: defaultTaxYear
        };
      } else {
        break;
      }
    case UPDATE_AID_YEAR:
      return {
        ...state,
        aidYear: action.payload,
        aidYearString: `${prevYear}-${action.payload}`,
        aidYearStart: `${prevYear}`,
        taxYear: taxYear
      };
    case RESET_GLOBAL:
      return {
        aidYear: 2021,
        aidYearStart: 2020,
        aidYearString: "2020-2021",
        taxYear: 2018,
        interviewTypesAll: null
      };
    case FETCH_INTERVIEW_TYPES_ALL:
      return {
        ...state,
        interviewTypesAll: action.payload
      };
    default:
      return state;
  }
};
